import { render, staticRenderFns } from "./Plugs.vue?vue&type=template&id=f44c96ba"
import script from "./Plugs.vue?vue&type=script&lang=js"
export * from "./Plugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports